export const INFO_RETRIEVED = 'INFO_RETRIEVED';
export const NETWORK_RETRIEVED = 'NETWORK_RETRIEVED';
export const MIN_RETRIEVED = 'MIN_RETRIEVED';
export const FEE_RETRIEVED = 'FEE_RETRIEVED';
export const FEES_RETRIEVED = 'FEES_RETRIEVED';
export const NO_NEW_SETTINGS = 'NO_NEW_SETTINGS';
export const GAS_KEY_RETRIEVED = 'GAS_KEY_RETRIEVED';
export const PRECIO_HOST_RETRIEVED = 'PRECIO_HOST_RETRIEVED';
export const SET_RATES = 'SET_RATES';